module.exports = __webpack_public_path__ + "static/media/page7.b8f51d1f.png";